export default __webpack_public_path__ + "static/t-moto-2a8efec4e30367774e26b0a52e6c6593.png";